const SESSION_KEYS = ["accessToken", "refreshToken", "user", "tokenExpiration", "authToken"];

export function clearStoredSession() {
  SESSION_KEYS.forEach(key => localStorage.removeItem(key));
}

export function readStoredUser<T>(): T | null {
  try {
    return JSON.parse(localStorage.getItem("user") || "null") as T | null;
  } catch {
    return null;
  }
}
